export default __webpack_public_path__ + "static/media/arnab.6cdcdce8.png";